import { render } from "./PattyPanel.vue?vue&type=template&id=5236c0a2&scoped=true"
import script from "./PattyPanel.vue?vue&type=script&lang=js"
export * from "./PattyPanel.vue?vue&type=script&lang=js"

import "./PattyPanel.vue?vue&type=style&index=0&id=5236c0a2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5236c0a2"]])

export default __exports__